import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../redux/actions";
import Main from "./Main";
import { withRouter } from "react-router";

function mapStateToProps(state) {
  return {
    users: state.users,
    tasks: state.tasks,
    filters: state.filters,
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

const App = withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));

export default App;
